import React from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableRow,
	TableHead,
	Typography,
} from "@mui/material";

const compactTableCellStyle = {
	fontFamily: "Roboto Condensed",
	fontSize: "0.75rem",
	padding: "6px 8px",
	lineHeight: "1.2",
};

const headerCellStyle = {
	...compactTableCellStyle,
	fontWeight: "bold",
	backgroundColor: "#f5f5f5",
};

const ImportTable = ({ data, title, customCaptions = {}, showAssetReferences = false, testIdPrefix }) => {

	if (data.length === 0) {
		return null;
	} else {
		return (
			<div style={{ marginTop: 12 }} data-testid={testIdPrefix ? `${testIdPrefix}-section` : undefined}>
				<Typography variant="subtitle1" style={{ fontFamily: "Roboto Condensed", fontSize: "1rem", marginBottom: 8 }}>
					{title}
				</Typography>
				<Table size="small" data-testid={testIdPrefix ? `${testIdPrefix}-table` : undefined}>
					<TableHead>
						<TableRow>
							<TableCell style={headerCellStyle}>{customCaptions?.asset || "Asset"}</TableCell>
							{showAssetReferences && (
								<TableCell style={{ ...headerCellStyle, whiteSpace: "nowrap" }}>
									{customCaptions?.assetReference || "Reference"}
								</TableCell>
							)}
							<TableCell style={headerCellStyle}>Description</TableCell>
							{showAssetReferences && (
								<>
									<TableCell style={{ ...headerCellStyle, whiteSpace: "nowrap" }}>
										Planner Group
									</TableCell>
									<TableCell style={{ ...headerCellStyle, whiteSpace: "nowrap" }}>
										Work Center
									</TableCell>
								</>
							)}
						</TableRow>
					</TableHead>
					<TableBody>
						{data.map((x, i) => (
							<TableRow key={i} data-testid={testIdPrefix ? `${testIdPrefix}-row-${i}` : undefined}>
								<TableCell style={compactTableCellStyle}>{x.assetNumber}</TableCell>
								{showAssetReferences && (
									<TableCell style={compactTableCellStyle}>{x.reference}</TableCell>
								)}
								<TableCell style={compactTableCellStyle}>{x.description}</TableCell>
								{showAssetReferences && (
									<>
										<TableCell style={compactTableCellStyle}>{x.plannerGroup}</TableCell>
										<TableCell style={compactTableCellStyle}>{x.workCenter}</TableCell>
									</>
								)}
							</TableRow>
						))}
					</TableBody>
				</Table>
			</div>
		);
	}
};

export default ImportTable;
